module.exports = __webpack_public_path__ + "src/assets/images/login/nitro_main_desktop.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/nitro_main_desktop.png
// module id = 2317
// module chunks = 4